import React from 'react';
import { Typography } from '@/UIlibrary/Typography/Typography';
import Button from '@/UIlibrary/Button/Button';
import {
	Table,
	TableHeader,
	TableBody,
	TableRow,
	TableHead,
	TableCell
} from '@/stories/Shadcn/Table/Table';
import { SyncResult } from '../../CustomerSupport/types';

interface FailedRecordsTableProps {
	failedRecords: SyncResult['failed_records'];
	isLoading: boolean;
	onRetry: () => void;
	t: (key: string, params?: any) => string;
}

const FailedRecordsTable: React.FC<FailedRecordsTableProps> = ({
	failedRecords,
	isLoading,
	onRetry,
	t
}) => {
	if (failedRecords.length === 0) return null;

	return (
		<div className="mb-6">
			<div className="mb-2 text-red-700">
				<Typography size="md" weight="medium">
					{t('FailedRecords')} ({failedRecords.length})
				</Typography>
			</div>
			<div className="max-h-60 overflow-y-auto border rounded">
				<Table>
					<TableHeader>
						<TableRow>
							<TableHead>{t('ClientId')}</TableHead>
							<TableHead>{t('Error')}</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{failedRecords.map((record, idx) => (
							<TableRow key={idx}>
								<TableCell>{record.client_id}</TableCell>
								<TableCell className="text-red-600">{record.error}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
			<div className="mt-4">
				<Button onClick={onRetry} disabled={isLoading} label={t('RetryFailed')} size="auto" />
			</div>
		</div>
	);
};

export default FailedRecordsTable;
